const EULER_TOKEN_IMAGE_BASE_URL = 'https://mewler-token-images-production.up.railway.app/999'
const HYPERLIQUID_TOKEN_IMAGE_BASE_URL = 'https://app.hyperliquid.xyz/coins/'

function extractTokenAddress(value?: string): string | undefined {
  if (!value) return undefined
  const match = value.match(/0x[a-fA-F0-9]{40}/)
  return match?.[0]?.toLowerCase()
}

function getEulerTokenImageUrl(tokenAddress?: string): string | undefined {
  const normalizedAddress = extractTokenAddress(tokenAddress)
  return normalizedAddress ? `${EULER_TOKEN_IMAGE_BASE_URL}/${normalizedAddress}` : undefined
}

function isHyperliquidImageUrl(url?: string): boolean {
  return !!url && url.startsWith(HYPERLIQUID_TOKEN_IMAGE_BASE_URL)
}

interface BuildTokenImageSrcChainParams {
  src: string
  fallbackSrc?: string
  tokenAddress?: string
  defaultFallbackSrc: string
  disableEulerFallback?: boolean
}

function isDefaultFallbackImage(src: string): boolean {
  return src.includes('/tokens/unknown.')
}

export function buildTokenImageSrcChain({
  src,
  fallbackSrc,
  tokenAddress,
  defaultFallbackSrc,
  disableEulerFallback = false,
}: BuildTokenImageSrcChainParams): string[] {
  const detectedTokenAddress = tokenAddress || extractTokenAddress(src) || extractTokenAddress(fallbackSrc)
  const eulerFallbackSrc = disableEulerFallback ? undefined : getEulerTokenImageUrl(detectedTokenAddress)
  const orderedSources =
    (isHyperliquidImageUrl(src) || isDefaultFallbackImage(src)) && eulerFallbackSrc
      ? [eulerFallbackSrc, src, fallbackSrc, defaultFallbackSrc]
      : [src, eulerFallbackSrc, fallbackSrc, defaultFallbackSrc]

  return orderedSources.filter((value, index, arr): value is string => {
    return !!value && arr.indexOf(value) === index
  })
}
